var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigCast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 20V15C5.5 13.6739 6.02678 12.4021 6.96447 11.4645C7.90215 10.5268 9.17392 10 10.5 10H50.5C51.8261 10 53.0979 10.5268 54.0355 11.4645C54.9732 12.4021 55.5 13.6739 55.5 15V45C55.5 46.3261 54.9732 47.5979 54.0355 48.5355C53.0979 49.4732 51.8261 50 50.5 50H35.5M5.5 30C10.6184 30.5432 15.3959 32.8249 19.0355 36.4645C22.6751 40.1041 24.9568 44.8816 25.5 50M5.5 40C7.98164 40.4622 10.2652 41.6649 12.0501 43.4499C13.8351 45.2348 15.0378 47.5184 15.5 50M5.5 50H5.525",
    stroke: "#4B286D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigCast);
export default __webpack_public_path__ + "static/media/big-cast.1ebb4cf8859f3ed8b7437ec56f64c8e0.svg";
export { ForwardRef as ReactComponent };